import ChangesCompanyDepartmentTemplate
  from "../../templates/ChangesCompanyDepartmentTemplate/ChangesCompanyDepartmentTemplate";

const ChangesCompanyDepartmentPage = () => {
  return <ChangesCompanyDepartmentTemplate />;
};

export default ChangesCompanyDepartmentPage;
